var _path, _path2, _rect, _path3, _path4, _rect2, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55192 19.9149C5.26485 18.8842 5.04195 17.7962 4.88599 16.6577C4.88599 8.51451 11.004 2 18.5508 2C26.0977 2 33.387 7.7002 33.387 16.2505C33.387 17.5073 33.2011 18.7365 32.8579 19.9149",
    stroke: "#43927C",
    strokeWidth: 0.769877
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.38063 21.2523C2.27919 24.128 4.72664 25.0571 7.15091 24.2996L4.3894 15.4619C1.96513 16.2194 0.640439 18.8835 1.38063 21.2523Z",
    fill: "#1CCF9E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.8623,
    y: 14.9307,
    width: 4.07157,
    height: 11.3734,
    rx: 2.03579,
    transform: "rotate(-10.127 1.8623 14.9307)",
    fill: "var(--operator-main-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7582 24.8008C30.5367 26.9723 26.7095 31.4782 21.1721 32.1296",
    stroke: "#43927C",
    strokeWidth: 0.769877
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6194 21.2523C35.7208 24.128 33.2734 25.0571 30.8491 24.2996L33.6106 15.4619C36.0349 16.2194 37.3596 18.8835 36.6194 21.2523Z",
    fill: "#1CCF9E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4.07157,
    height: 11.3734,
    rx: 2.03579,
    transform: "matrix(-0.984421 -0.17583 -0.17583 0.984421 36.1375 14.9307)",
    fill: "var(--operator-main-color)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5144 9.73598C9.3645 5.17583 14.0179 2 19.5434 2C25.4848 2 29.7224 5.66441 32.1653 10.1431",
    stroke: "var(--operator-main-color)",
    strokeWidth: 3.07951,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8967 32.6729C17.7955 32.024 18.2394 31.416 18.8882 31.3147L20.6758 31.0357C21.0959 30.9701 21.4896 31.2575 21.5552 31.6776L21.6845 32.5059C21.7501 32.926 21.4627 33.3197 21.0426 33.3853L19.2549 33.6643C18.6061 33.7656 17.998 33.3217 17.8967 32.6729Z",
    fill: "var(--operator-main-color)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5868 10.8193H22.3381C25.1012 10.8193 27.3411 13.0593 27.3411 15.8224V19.614C27.3411 21.5519 26.2219 23.3156 24.4684 24.1408L20.5584 25.9808V24.2977C20.5584 23.4644 19.8828 22.7889 19.0495 22.7889H15.5868C12.8237 22.7889 10.5837 20.549 10.5837 17.7859V15.8224C10.5837 13.0593 12.8237 10.8193 15.5868 10.8193ZM14.1091 17.8705C14.7341 17.8705 15.2407 17.3638 15.2407 16.7388C15.2407 16.1138 14.7341 15.6072 14.1091 15.6072C13.4841 15.6072 12.9775 16.1138 12.9775 16.7388C12.9775 17.3638 13.4841 17.8705 14.1091 17.8705ZM19.7673 16.7388C19.7673 17.3638 19.2607 17.8705 18.6357 17.8705C18.0107 17.8705 17.504 17.3638 17.504 16.7388C17.504 16.1138 18.0107 15.6072 18.6357 15.6072C19.2607 15.6072 19.7673 16.1138 19.7673 16.7388ZM23.1623 17.8705C23.7873 17.8705 24.294 17.3638 24.294 16.7388C24.294 16.1138 23.7873 15.6072 23.1623 15.6072C22.5373 15.6072 22.0307 16.1138 22.0307 16.7388C22.0307 17.3638 22.5373 17.8705 23.1623 17.8705Z",
    fill: "#E7B92A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.c8c30e481cbf42e3e8e1bd02e57ae85d.svg";
export { ForwardRef as ReactComponent };